import { createOptionArray } from 'Shared/backend/widgets/ComponentOptions';
import { selectStyle } from 'Shared/forms/Inputs';
import { LayoutTypes } from 'Shared/model/Components';
import { useStore } from 'Shared/StoreProvider';
import { Show, For } from 'solid-js';
import { subdoc } from 'Common/ViewUtils';


export function LayoutSelector(P:{layout:LayoutTypes,required?:boolean,options:LayoutTypes[],isTop?:boolean;expand?:()=>void})
{
	const sw = useStore();

//TODO add warning about losing content?

	const changeBlock = async e => {
		const newLayout = e.target.value;
		const content = initContent(subdoc(sw.store,sw.location),newLayout,P.isTop===true);

		await sw.server.replace.mutate({page:sw.page,permission:sw.permission,id:sw.docId,location:sw.location,fields:content});
		sw.setStore(...sw.location,content);

		P.expand?.();
	};

	return (
		<select class={selectStyle()} onChange={changeBlock} onClick={e => e.stopPropagation()}>
			<Show when={!P.required}>
				<option value='' selected={!P.layout}>None</option>
			</Show>

			<For each={Object.entries(createOptionArray(P.options))}>{ item => 
				<option value={item[0]} selected={item[0]==P.layout}>
					{item[1]}
				</option>
			}</For>
		</select>
	);
}

export function initImage()
{
	return {layout:'image',upload:{},display:{fit:'cover',position:'center',parent:true,size:'medium'}};
}

export function initVisualWithImage()
{
	return {layout:'visualWithInfo',visual:initImage(),visualPosition:'left',upper:{layout:'text',type:'title'}, lower:{layout:'text',type:'plain'}};
}

export function initContent(old:any,layout:LayoutTypes,isTop:boolean)
{
	if (layout=='')
		return undefined;

	/* Reuse old children wherever we can */
	let items, content;
	if (old) {
		items = old.items ?? old.slides ?? (old.content ? [old.content] : undefined);
		content = old.content ?? (old.items ? old.items[0] : undefined) ?? (old.slides ? old.slides[0] : undefined) ?? initImage();
//XXX cf including 'background' and/or 'upper'? Less clear these are the best choices...
	}

	let ret:any = { layout };

//XXX posters missing here?

	if (layout=='image') 
		ret = initImage();
	else if (layout=='styles') {
		ret = {
			...(old ?? {content: initImage()}),
			height: isTop ? {child:true} : {parent:true},
			layout: 'styles'
		}; 
	}
	else if (layout=='link') 
		ret = {...ret, content,openInSameWindow:false}; 
	else if (layout=='popup') 
		ret = {...ret, content}; 
	else if (layout=='grid')
		ret = {...ret, fold:true,itemsPerRow:2,cellHeight:{height:'500px'},align:'stretch',items}; 
	else if (layout=='vertical')
		ret = {...ret,items}; 
	else if (layout=='overlay') 
		ret = {...ret, 
			height:isTop ? {child:true} : {parent:true},
			foreground:initImage(),
			background:initImage(),
			foregroundHeight:{child:true},
			vertical:{side:'center'},
			horizontal:{side:'center'}
		};
	else if (layout=='text') 
		ret = {...ret, type:'title'};
	else if (layout=='buttons') 
		ret = {...ret, align:'left'};
	else if (layout=='slides') 
		ret = {...ret, height:{height:'80vh'},slides:items};
	else if (layout=='embed') 
		ret = {...ret, type:'iframe',height:isTop ? {height:'500px'} : {parent:true}};
	else if (layout=='visualWithInfo') 
		ret = initVisualWithImage();

	return ret;
}

